// Pub/sub module-level pour la page « accès suspendu » (abonnement), sur le
// modèle de queueGate.js : l'intercepteur axios de lib/api.js (hors de
// l'arbre React) déclenche l'état dès qu'un appel renvoie
// 402 { code: "subscription_blocked", … } — voir backend/tenancy.py
// (vitrine) et services/admin_service.py (back-office de la boutique).
// App.js bascule alors tout l'arbre sur <SubscriptionBlocked/>.

let state = null; // null = ouvert ; {reason, title, message, support_email, support_phone, shop_name, since}
const listeners = new Set();

export function getSubscriptionBlock() {
  return state;
}

export function setSubscriptionBlock(next) {
  state = next;
  listeners.forEach((l) => l(state));
}

export function subscribeSubscriptionBlock(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// Corps d'erreur → état, ou null si ce n'est pas un blocage d'abonnement.
export function blockFromError(error) {
  const detail = error?.response?.status === 402 ? error.response?.data?.detail : null;
  if (!detail || typeof detail !== "object" || detail.code !== "subscription_blocked") return null;
  return {
    reason: detail.reason || "manual",
    title: detail.title || "Accès suspendu",
    message: detail.message || "",
    support_email: detail.support_email || "",
    support_phone: detail.support_phone || "",
    shop_name: detail.shop_name || "",
    since: detail.since || null,
  };
}
